import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Producto } from '../../../_models/producto';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ListaItem } from '../../../_models/lista-item';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { Location } from '@angular/common';
import { ListaService } from '../../../_services/lista.service';
import { forkJoin } from 'rxjs';
import { ProductoFrecuencia } from '../../../_models/producto-frecuencia';
import { ProductoFrecuenciaService } from '../../../_services/producto-frecuencia.service';
import { Dialog } from 'primeng/dialog';
import { sleep } from '../../../utils/utilidades';

@Component( {
  selector: 'app-producto-frecuencia',
  templateUrl: 'producto-frecuencia.component.html'
} )

export class ProductoFrecuenciaComponent implements OnInit {

  @Input() producto: Producto;
  lisFrecuencias: SelectItem[] = [];
  lisFrecuenciasTodos: ListaItem[] = [];
  carInformacionInicial = true;
  lisProductosFrecuencias: ProductoFrecuencia[] = [];
  lisProductosFrecuenciasTemp: ProductoFrecuencia[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = true;
  columnas: any[];
  showModalFrecuenciasCuotas = false;
  proFrecuencia: ProductoFrecuencia;
  @ViewChild('dialog') dialogo: Dialog;

  constructor( private proFrecuenciaServicio: ProductoFrecuenciaService,
               private navServicio: NavService,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private lisServicio: ListaService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'id', header: this.navServicio.buscarMensaje( 'LBL_ID' ), sort: false },
      { field: 'nombreFrecuenciaProducto', header: this.navServicio.buscarMensaje( 'PRODUCTOFRECUENCIA.LBL_FRECUENCIA' ), sort: false },
      { field: 'indicadorAnalizamos', header: this.navServicio.buscarMensaje( 'PRODUCTOFRECUENCIA.LBL_INDICADORANALIZAMOS' ), sort: false },
      { field: 'indicadorCreditoDigital', header: this.navServicio.buscarMensaje( 'PRODUCTOFRECUENCIA.LBL_INDICADORCRDITODIGITAL' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    forkJoin( this.proFrecuenciaServicio.listadoPorProducto( this.producto.idProducto ),
      this.lisServicio.getMasterDetails( 'ListasFrecuenciasProductos' )
    ).subscribe( ( [ lisProductosFrecuencias, lisFrecuencias ] ) => {
      this.lisFrecuenciasTodos = lisFrecuencias;
      this.lisProductosFrecuencias = lisProductosFrecuencias;
      let _contador = 0;
      lisProductosFrecuencias.forEach( l => {
        this.lisProductosFrecuenciasTemp[_contador] = Object.assign({}, l);
        _contador++;
      });
      this.cargarFormulario();
      this.cargarListadoFrecuencias();
      this.carInformacionInicial = false;
      this.guardando = false;
    } );
  }

  cargarListadoFrecuencias() {
    this.lisFrecuencias = [];
    this.lisFrecuenciasTodos.map( ( s: ListaItem ) => {
      this.lisFrecuencias.push( { label: s.nombre, value: s.idLista } );
      /*if ( !this.lisProductosFrecuencias.find( x => x.idFrecuenciaProducto === s.idLista ) ) {
        this.lisFrecuencias.push( { label: s.nombre, value: s.idLista } );
      }*/
    } );
  }


  cargarFormulario() {
    this.formulario = this.fb.group( {
      idFrecuencias: [ [], [ Validators.required ] ],
      indicadorAnalizamos: [ true, []],
      indicadorDigital: [ false, []]
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid && (this.f.indicadorAnalizamos.value || this.f.indicadorDigital.value)) {
      this.guardando = true;
      const proFrecuenciaCrear = this.formulario.value;
      const freAgregar = [];
      if ( proFrecuenciaCrear.idFrecuencias ) {
        proFrecuenciaCrear.idFrecuencias.map( s => {
          const regAgregar = {
            idProducto: this.producto.idProducto,
            idFrecuenciaProducto: s,
            indicadorHabilitado: true,
            indicadorAnalizamos: proFrecuenciaCrear.indicadorAnalizamos,
            indicadorDigital: proFrecuenciaCrear.indicadorDigital,
            indicadorAliado: false
          };
          freAgregar.push( regAgregar );
        } );
      }

      if ( freAgregar.length > 0 ) {
        if (this.validarFrecuencia(freAgregar)) {
          this.proFrecuenciaServicio.bulk( freAgregar ).subscribe( frecuencia => {
            frecuencia.map( ( s: ProductoFrecuencia ) => {
              const d = this.lisFrecuenciasTodos.find( x => x.idLista === s.idFrecuenciaProducto );
              if ( d ) {
                s.nombreFrecuenciaProducto = d.nombre;
              }
              // this.lisProductosFrecuencias.push( s );
              this.lisProductosFrecuencias = [ ...this.lisProductosFrecuencias, s ];
              this.lisProductosFrecuenciasTemp = this.lisProductosFrecuencias;
            } );
            // this.cargarListadoFrecuencias();
            this.formulario.reset();
            this.f.indicadorAnalizamos.setValue(true);
            this.submitted = false;
            this.guardando = false;
            this.navServicio.setMesage( 1 );
          }, error => {
            this.guardando = false;
            this.navServicio.setMesage( 3 );
          } );
        } else {
          this.navServicio.setMesage( 0, {
            severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'PRODUCTOFRECUENCIA.MSG_ERRORFRECUENCIA' )
          } );
          this.guardando = false;
        }
      } else {
        this.navServicio.setMesage( 1 );
        this.guardando = false;
      }

    }
  }

  inhabilitar( proFrecuencia: ProductoFrecuencia ) {
    if ( this.producto.indicadorHabilitado && this.lisProductosFrecuencias.length === 1 ) {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_NOINHABILITAR' )
      } );
    } else {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'frecuencias',
        accept: () => {
          this.carInformacionInicial = true;
          proFrecuencia.indicadorHabilitado = false;
          this.proFrecuenciaServicio.actualizar( proFrecuencia ).subscribe( regActualizado => {
            const a = this.lisProductosFrecuencias.findIndex( x => x.idProductoFrecuencia === proFrecuencia.idProductoFrecuencia );
            if ( a >= 0 ) {
              this.lisProductosFrecuencias.splice( a, 1 );
            }
            // this.cargarListadoFrecuencias();
            this.carInformacionInicial = false;
          } );
        },
        reject: () => {
        }
      } );
    }
  }

  regresar() {
    this.location.back();
  }

  abrirModalFrecuenciaCuotas(proFrecuencia: ProductoFrecuencia){
    this.proFrecuencia = proFrecuencia;
    this.showModalFrecuenciasCuotas = true;
  }

  cerrarModalFrecuenciaCuotas() {
    this.proFrecuencia = null;
    this.showModalFrecuenciasCuotas = false;
  }

  async centrarDialog() {
    await sleep( 50 );
    this.dialogo.center();
  }

  validarFrecuencia(formualrio?: any[], data?: any,  individual: boolean = false) {
    let _validacion: boolean = true;
    if (!individual) {
      formualrio.forEach( f => {
        if (this.lisProductosFrecuencias.filter( l => l.idFrecuenciaProducto === f.idFrecuenciaProducto
          && ((l.indicadorAnalizamos === f.indicadorAnalizamos || l.indicadorDigital === f.indicadorDigital)
            || (l.indicadorAnalizamos === f.indicadorAnalizamos && l.indicadorDigital === f.indicadorDigital))).length > 0) {
          _validacion = false;
          return;
        }
      });
    } else {
      const _copy = this.lisProductosFrecuenciasTemp;
      const _filtrado = _copy.filter(l => l.idFrecuenciaProducto === data.idFrecuenciaProducto
        && l.idProductoFrecuencia !== data.idProductoFrecuencia);
      _filtrado.forEach( c => {
        if (c.indicadorAnalizamos === data.indicadorAnalizamos && data.indicadorAnalizamos) {
          _validacion = false;
        } else if (c.indicadorDigital === data.indicadorDigital && data.indicadorDigital) {
          _validacion = false;
        } else if (c.indicadorDigital === data.indicadorDigital && c.indicadorAnalizamos === data.indicadorAnalizamos) {
          _validacion = false;
        }
      });
    }
    return _validacion;
  }

  actualizarIndicador(data: ProductoFrecuencia, indicador) {
    const a = this.lisProductosFrecuencias.findIndex( x => x.idProductoFrecuencia === data.idProductoFrecuencia );
    if (this.validarFrecuencia([], data, true)) {
      this.proFrecuenciaServicio.actualizar( data ).subscribe( regActualizado => {
        this.navServicio.setMesage(2);
        this.lisProductosFrecuenciasTemp[a] = Object.assign({}, data);
      } );
    } else {
      if (a !== -1) {
        if (indicador === 'A') {
          this.lisProductosFrecuencias[a].indicadorAnalizamos = false;
        } else {
          this.lisProductosFrecuencias[a].indicadorDigital = false;
        }
        this.lisProductosFrecuencias[a] = Object.assign({}, this.lisProductosFrecuencias[a]);
      }
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'PRODUCTOFRECUENCIA.MSG_ERRORFRECUENCIA' )
      } );
    }
  }

}
